import * as React from 'react';
import { Link } from 'react-router-dom';
import { UpdatedResult } from '../../../types/StatTypes';
import DiffSpan from '../../general/DiffSpan';
import { getWiktionaryUrl } from '../../card/ExternalLinksDropdown';

export function LastResultStat(props: { lastResult: UpdatedResult; }) {
    const oldStrength = (props.lastResult.oldStrength).toFixed(2);
    const newStrength = (props.lastResult.newStrength).toFixed(2);
    const delta = parseFloat(newStrength) - parseFloat(oldStrength);

    var wiktionaryUrl = getWiktionaryUrl(props.lastResult.phrase, props.lastResult.wiktionaryLanguage)
    return (
        <span>
            <span>| </span>
            <Link to={`/cards/${props.lastResult.cardId}`}
                style={{ color: props.lastResult.isOldOnHold ? 'orange' : undefined }}>
                {oldStrength}
            </Link>

            {wiktionaryUrl ? < Link to={wiktionaryUrl}
                target="_blank"
                className="fw-normal">
                <DiffSpan value={delta} oldValue={0.00} addPlus={true} valuePrecision={2} />
            </Link>
                :
                <DiffSpan value={delta} oldValue={0.00} addPlus={true} valuePrecision={2} />
            }
            =
            <Link to={`/results/${props.lastResult.id}`}
                style={{ color: props.lastResult.isNewOnHold ? 'orange' : undefined }}>
                {newStrength}
            </Link>
        </span>
    );
}
